export default function TestimonialsSection() {
  const testimonials = [
    {
      name: '中3保護者 T様',
      grade: '息子が中2から通塾',
      image: 'https://public.readdy.ai/ai/img_res/4016753a1e9d513f7eda0e886df77519.jpg',
      comment: '息子は勉強が苦手で、定期テストの点数も伸び悩んでいました。学習塾NICKに通い始めてから、先生方の丁寧な指導のおかげで、勉強への取り組み方が変わりました。特に数学が苦手でしたが、基礎から丁寧に教えていただき、今では得意科目になっています。廿日市市で信頼できる学習塾を探している方に、ぜひおすすめしたいです。',
      rating: 5
    },
    {
      name: '中2保護者 S様',
      grade: '娘が中1から通塾',
      image: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20mother%20illustration%20smiling%20warm%20expression%20simple%20clean%20background%20soft%20pastel%20colors%20gentle%20art%20style%20cartoon%20character%20portrait%20minimalist%20design%20cheerful%20atmosphere&width=400&height=500&seq=parent-illust002&orientation=portrait',
      comment: '少人数指導なので、娘の理解度に合わせて授業を進めてくださるのが良いです。提出物の管理もしっかりサポートしていただけるので、内申点対策も安心です。先生方が公立高校での経験をお持ちなので、高校受験についても的確なアドバイスをいただけます。廿日市市大野で学習塾を探している方には、本当におすすめです。',
      rating: 5
    },
    {
      name: '中3保護者 Y様',
      grade: '息子が中3から通塾',
      image: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20father%20illustration%20smiling%20warm%20expression%20simple%20clean%20background%20soft%20pastel%20colors%20gentle%20art%20style%20cartoon%20character%20portrait%20minimalist%20design%20cheerful%20atmosphere&width=400&height=500&seq=parent-illust003&orientation=portrait',
      comment: '高校受験を控えた中3から通い始めましたが、志望校合格に向けて計画的に指導していただいています。過去問演習や模試対策も充実しており、息子も自信を持って受験に臨めそうです。個別指導と少人数指導を組み合わせたスタイルが、息子には合っていたようです。廿日市市で高校受験対策をお考えの方に、ぜひ無料体験をおすすめします。',
      rating: 5
    }
  ];

  return (
    <section className="py-24 bg-[#f8f9fa]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a2332] mb-4">
            保護者の声
          </h2>
          <p className="text-gray-600 text-lg">
            学習塾NICKを選んでいただいた保護者様からのメッセージ
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-[#1a2332] rounded-3xl overflow-hidden shadow-2xl hover:-translate-y-2 transition-all duration-300"
            >
              <div className="relative">
                <div className="h-64 overflow-hidden">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute top-6 left-6">
                  <i className="ri-double-quotes-l text-6xl text-[#ffd700] opacity-80"></i>
                </div>
              </div>

              <div className="p-8">
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xl text-[#ffd700]"></i>
                  ))}
                </div>

                <p className="text-white leading-relaxed mb-6">
                  {testimonial.comment}
                </p>

                <div className="border-t border-white/20 pt-6">
                  <p className="text-white font-semibold text-lg mb-1">
                    {testimonial.name}
                  </p>
                  <p className="text-white/70 text-sm">
                    {testimonial.grade}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            <strong>廿日市市大野</strong>の学習塾NICKでは、保護者様との密なコミュニケーションを大切にしています。定期的な面談で学習状況をお伝えし、ご家庭と連携しながらお子様の<strong>成績アップ</strong>をサポートします。
          </p>
        </div>
      </div>
    </section>
  );
}
